import { cn } from '../../../lib';
import { Skeleton, Table, TableBody, TableCell, TableRow } from '../../../ui';

interface ISimpleTableWidgetLoaderProps {
  itemsCount?: number;
  title: string;
}

/**
 * -----------------------------------------------------------------------------
 * Loading skeleton for the a simple information table
 */
export function SimpleTableWidgetLoader({
  itemsCount = 5,
  title,
}: ISimpleTableWidgetLoaderProps) {
  const placeholders = Array.from(
    { length: itemsCount },
    (_, index) => index + 1
  );

  return (
    <div className="flex w-full flex-col gap-4 py-4 md:gap-6 md:py-4">
      <div
        className="
          shadow-loader-background/50 flex flex-col space-x-4 rounded border
          shadow-sm
        "
      >
        <div className="flex flex-col">
          <div className="space-y-4 p-6">
            <h5 className="text-foreground opacity-15">{title}</h5>

            <div className="text-foreground-light flex flex-col space-y-2">
              <div className="text-text-caption text-sm">
                <Skeleton className="h-4 w-full" />
                <Skeleton className="mt-1 hidden h-4 w-96" />
              </div>
            </div>
          </div>
        </div>

        <Table className="w-full table-fixed border-t">
          <TableBody>
            {placeholders.map((row, index) => (
              <TableRow
                key={row}
                className={cn(
                  'w-full cursor-wait',
                  index % 2 && 'bg-neutral-300/5 dark:bg-neutral-800/5'
                )}
              >
                <TableCell className="px-6 py-4 text-start">
                  <Skeleton className="h-4 w-24" />
                </TableCell>
                <TableCell className="space-x-1 px-6 py-4 text-end">
                  <Skeleton className="inline-block h-4 w-8" />
                  <Skeleton className="inline-block h-4 w-16 font-mono" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
